<template>
  <div v-if="dataArr&&dataArr.length">
    <div :class="isTourname?'img':'fximg'">
      <img v-if="dataArr&&dataArr[0].amtopics&&(String(dataArr[0].amtopics).startsWith('http')||String(dataArr[0].amtopics).startsWith('https'))" :src="dataArr[0].amtopics" alt="" >
      <img  v-else  src="../imgs/noViewPic.jpg" />
    </div>
    <div :class="isTourname?'':'wrap_iviewNew'">
      <div :class="isTourname?'iviewNew':'fxiviewNew'"  v-for="(item,index) in dataArr" :key="index" >
        <Row :style="{margin:'5px 0'}" v-if="isTourname?index<4:index<5">
          <Col span="16" :style="{marginRight:'25px',textAlign:'left'}" >
            <p class="tit" @click="detail(item.amid)" >{{ item.amtopicf }}</p>
          </Col>
          <Col span="6" :style="{textAlign:'right'}" >
            <p class="time">{{ item.dtmakedate.split(' ')[0] }}</p>
          </Col>
        </Row>
      </div>
    </div>
  </div>
  <div
    v-else
    class="noData"
  >暂无数据</div>
</template>
<script>
export default {
  props: {
    dataArr: {
      type: Array,
      default: [],

    }
  },
  data () {
    return {
      isTourname: sessionStorage.getItem('lgtp') === '02' ? false : true,
    }
  },
  methods: {
    detail (amid) {
      this.$router.push({
        name: 'articleDetail',
        params: {
          aId: amid,
          part: '旅游攻略',
          partName: 'information'
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
@fontSize12: 12px;
@fontSize14: 14px;
@titColor: #323233;
@timeColor: #969799;
@hoverColor: #4b7ff0;
@lineHeight: 20px;
@fxlineHeight: 30px;
.img {
  width: 100%;
  height: 160px;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
.iviewNew {
  font-size: @fontSize12;
  .tit {
    font-size: @fontSize14;
    line-height: @lineHeight;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: @hoverColor;
    }
    color: @titColor;
  }
  .time {
    line-height: @lineHeight;
    color: @timeColor;
  }
}
// 暂无数据样式
.noData {
  text-align: center;
  line-height: 250px;
}
// 分销商样式
.fximg {
  width: 100%;
  height: 220px;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
.wrap_iviewNew {
  height: 170px;
}
.fxiviewNew {
  font-size: @fontSize12;
  .tit {
    font-size: @fontSize14;
    line-height: @fxlineHeight;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      color: @hoverColor;
    }
    color: @titColor;
  }
  .time {
    line-height: @fxlineHeight;
    color: @timeColor;
  }
}
</style>


